// src/components/common/ProductCard.jsx
import React from "react";
import { Link } from "react-router-dom";

const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 500'%3E%3Crect width='400' height='500' fill='%23F5F0E8'/%3E%3Cg fill='%23C9BFA8'%3E%3Cpath d='M150 200h100v100H150z' fill='none' stroke='%23C9BFA8' stroke-width='6'/%3E%3Ccircle cx='175' cy='225' r='10'/%3E%3Cpath d='M150 280l30-30 20 20 30-40 40 50H150z'/%3E%3C/g%3E%3Ctext x='200' y='340' font-family='sans-serif' font-size='16' fill='%23A89B7D' text-anchor='middle'%3EImage coming soon%3C/text%3E%3C/svg%3E";

// Badge priority: sold out > featured > trending > new arrival
// (ek time pe sirf ek hi badge dikhega, taaki card clutter na ho)
function getBadge(product) {
  if (product.isSoldOut) {
    return { label: "Sold Out", bg: "#FFD600", color: "#1A1A1A" };
  }
  if (product.isFeatured) {
    return { label: "Featured", bg: "#FFD600", color: "#1A1A1A" };
  }
  if (product.isTrending) {
    return { label: "Trending", bg: "#FFD600", color: "#1A1A1A" };
  }
  if (product.isBestSeller) {
    return { label: "Best Seller", bg: "#FFD600", color: "#1A1A1A" };
  }
  if (product.isNewArrival) {
    return { label: "New", bg: "#FFD600", color: "#1A1A1A" };
  }
  return null;
}

export default function ProductCard({ product, basePath = "/dailyplanners" }) {
  if (!product) return null;

  const badge = getBadge(product);
  const isSoldOut = product.isSoldOut;

  return (
    <Link to={`${basePath}/${product.id}`} className="group block w-full">
      {/* Image */}
      <div className="relative aspect-[4/5] w-full bg-transparent">
        {badge && (
          <span
            className="absolute top-2 left-2 z-10 text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide shadow-sm"
            style={{ background: badge.bg, color: badge.color }}
          >
            {badge.label}
          </span>
        )}
        <img
          src={product.image || PLACEHOLDER_IMAGE}
          alt={product.name}
          loading="lazy"
          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = PLACEHOLDER_IMAGE; }}
          className={`h-full w-full object-contain transition-transform duration-500 ease-out group-hover:scale-[1.03] ${isSoldOut ? "opacity-50" : ""}`}
        />
      </div>

      {/* Text */}
      <div className="mt-4 text-center px-1 font-sans">
        <h3 className="text-[15px] font-bold leading-snug text-black tracking-wide">
          {product.name}
        </h3>

        <p className="text-[12px] text-gray-500 mt-1 font-medium">
          {product.subtitle || "Daily Planner"}
        </p>

        <div className="mt-2 flex items-center justify-center gap-2 text-sm">
          <span className="font-bold text-black">
            Rs. {product.price?.toLocaleString("en-IN")}
          </span>

          {product.comparePrice && (
            <span className="bg-[#fce954] px-1.5 py-0.5 text-black line-through text-[12px] font-bold rounded-sm shadow-sm">
              Rs. {product.comparePrice?.toLocaleString("en-IN")}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}